// ContactInfo.tsx
import React, {useEffect, useState} from "react";
import {SecurityUser, SelectOption} from "../../../api/ApiTypes.ts";
import {SamSelect} from "../../../components/SamSelect.tsx";
import {useConstantsApi, useUserApi} from "../../../context/ApiContext.tsx";
import {AppraiserProfileTabProps} from "./AppraiserProfile.tsx";
import {Loader2} from "lucide-react";


export const ContactInfo: React.FC<AppraiserProfileTabProps> = ({appraiserInfo}) => {
    const [user, setUser] = useState<SecurityUser | null>(null);
    const [mobileOperatingSystems, setMobileOperatingSystems] = useState<SelectOption[]>([]);
    const [selectedMobileOperatingSystem, setSelectedMobileOperatingSystem] = useState(appraiserInfo.mobileOperatingSystemType);
    const [isLoading, setIsLoading] = useState(true);
    const userApi = useUserApi();
    const constantsApi = useConstantsApi();
    console.log(appraiserInfo);

    useEffect(() => {

        setIsLoading(true);
        userApi.getSecurityUser(appraiserInfo.securityUser)
            .then((user) => {
                setUser(user);
            })
            .finally(() => {
                setIsLoading(false)
            })
            .catch(console.log);

        constantsApi.getMobileOperatingSystemTypes()
            .then(setMobileOperatingSystems)
            .catch(() => setMobileOperatingSystems(([])));
    }, [appraiserInfo]);

    return (
        <div>
            {isLoading ? (
                <div className="p-4 flex justify-center items-center">
                    <Loader2 className="h-8 w-8 text-blue-500 animate-spin mb-2"/>
                </div>
            ) : (
                <div className="space-y-6">
                    {/* Personal Information */}
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div>
                            <label className="block text-sm font-medium text-slate-700 mb-1">First Name</label>
                            <input
                                type="text"
                                className="w-full px-3 py-2 bg-slate-50 border border-slate-300 rounded-md text-slate-700"
                                value={user?.firstName}
                                disabled
                            />
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-slate-700 mb-1">Last Name</label>
                            <input
                                type="text"
                                className="w-full px-3 py-2 bg-slate-50 border border-slate-300 rounded-md text-slate-700"
                                value={user?.lastName}
                                disabled
                            />
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-slate-700 mb-1">Email</label>
                            <input
                                type="email"
                                className="w-full px-3 py-2 bg-slate-50 border border-slate-300 rounded-md text-slate-700"
                                value={user?.email}
                                disabled
                            />
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-slate-700 mb-1">Login ID</label>
                            <input
                                type="text"
                                className="w-full px-3 py-2 bg-slate-50 border border-slate-300 rounded-md text-slate-700"
                                value={user?.loginId}
                                disabled
                            />
                            <p className="mt-1 text-sm text-slate-500">This is your unique login identifier and cannot
                                be changed.</p>
                        </div>
                    </div>

                    {/* Phone Numbers */}
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div>
                            <label className="block text-sm font-medium text-slate-700 mb-1">Work Phone</label>
                            <input
                                type="tel"
                                className="w-full px-3 py-2 bg-slate-50 border border-slate-300 rounded-md text-slate-700"
                                value={user?.workPhone}
                                disabled
                            />
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-slate-700 mb-1">Cell Phone</label>
                            <input
                                type="tel"
                                className="w-full px-3 py-2 bg-slate-50 border border-slate-300 rounded-md text-slate-700"
                                value={user?.cellPhone}
                                disabled
                            />
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-slate-700 mb-1">Mobile Operating System</label>
                            <SamSelect
                                value={selectedMobileOperatingSystem}
                                onChange={setSelectedMobileOperatingSystem}
                                options={mobileOperatingSystems}
                                disabled
                                placeholder="-- Select --"
                            />
                        </div>
                    </div>

                    {/* Office Address */}
                    {appraiserInfo != null && (
                        <div>
                            <h3 className="text-md font-medium text-slate-700 mb-3">Office Address</h3>
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                <div className="md:col-span-2">
                                    <label className="block text-sm font-medium text-slate-700 mb-1">Street
                                        Address</label>
                                    <input
                                        type="text"
                                        className="w-full px-3 py-2 bg-slate-50 border border-slate-300 rounded-md text-slate-700"
                                        value={appraiserInfo?.officeAddressLine1 + (appraiserInfo?.officeAddressLine2 ? `, ${appraiserInfo?.officeAddressLine2}` : '')}
                                        disabled
                                    />
                                </div>
                                <div>
                                    <label className="block text-sm font-medium text-slate-700 mb-1">City</label>
                                    <input
                                        type="text"
                                        className="w-full px-3 py-2 bg-slate-50 border border-slate-300 rounded-md text-slate-700"
                                        value={appraiserInfo?.officeCity}
                                        disabled
                                    />
                                </div>
                                <div>
                                    <label className="block text-sm font-medium text-slate-700 mb-1">State</label>
                                    <input
                                        type="text"
                                        className="w-full px-3 py-2 bg-slate-50 border border-slate-300 rounded-md text-slate-700"
                                        value={appraiserInfo?.officeStateCode}
                                        disabled
                                    />
                                </div>
                                <div>
                                    <label className="block text-sm font-medium text-slate-700 mb-1">Property Zip
                                        Code</label>
                                    <input
                                        type="text"
                                        className="w-full px-3 py-2 bg-slate-50 border border-slate-300 rounded-md text-slate-700"
                                        value={appraiserInfo?.officeZipCode}
                                        disabled
                                    />
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};